import { checkNameOrTagAvailability, creationClan, finishCheckAvailabilityCreationClan, startCheckAvailabilityCreationClan, updateFieldValueCreationClan } from "fe2/Actions/ActionClanCreate";
import { hideDialog, showDialog } from "fe2/Actions/ActionDialog";
import { connect } from "react-redux";
import { ClanCreate } from "UIKit";

const mapStateToProps = state => {
  return {
    tag: state.clanCreate.tag,
    name: state.clanCreate.name,
    currentAccount: state.currentAccount,
    error: state.clanCreate.error,
    isProcessing: state.clanCreate.isProcessing,
    url: state.urls.checkClanNameTagAvability,
    clanRulesContent: state.content.clansRulesPage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValidateOnServer: (field, value) => {
      dispatch(startCheckAvailabilityCreationClan(field));
      return dispatch(checkNameOrTagAvailability(field, value, finishCheckAvailabilityCreationClan));
    },
    onCreateClanClick: () => dispatch(creationClan()),
    onUpdateFieldValue: (field, value, error) => dispatch(updateFieldValueCreationClan(field, value, error)),
    onShowDialog: (content, size) => dispatch(showDialog(content, size)),
    onHideDialog: () => dispatch(hideDialog())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClanCreate);